import React from 'react'
import './Footer.css'

function Footer() {
    return (

        <div className="row align-items-center">
            <div className="col-12 footer p-0 text-center" style={{height: '5vh', lineHeight: '5vh', backgroundColor: '#d0dcff'}}>
            <p style={{color:'#386ab3'}}>© 2023 Copyright: Storkini.rs </p>
            </div>
            
        </div>

    )
}

export default Footer
